import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const CarpetCleaning = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my carpet cleaning business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps carpet cleaning businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for carpet cleaning businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most carpet cleaning businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my carpet cleaning business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like carpet cleaning. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Carpet Cleaning - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Carpet Cleaning CRM", url: "/industries/carpet-cleaning" }
  ];

  const industryData = {
    name: 'Carpet Cleaning',
    title: 'Book More Jobs & Convert One-Time Cleans into Annual Contracts',
    subtitle: 'Capture booking requests 24/7, automate seasonal reminders, and build recurring revenue from every customer',
    icon: '🧹',
    challenges: [
      'Calls come in while on jobs',
      'Clients forget about annual cleaning',
      'Hard to fill schedule gaps',
      'One-time customers never return',
      'Time wasted on phone estimates'
    ],
    solutions: [
      'Online booking captures calls 24/7',
      'Automated annual cleaning reminders',
      'Last-minute availability alerts',
      'Recurring service plan automation',
      'Instant online quotes by room size'
    ],
    features: [
      'Customer CRM with cleaning history',
      'Online booking and scheduling',
      'Automated seasonal reminders',
      'Instant quote calculator',
      'Before/after photo galleries',
      'Recurring service tracking',
      'Review automation',
      'Service area mapping'
    ],
    results: [
      '55% become annual customers',
      'Book 40% more jobs',
      'Fill 85% of schedule gaps',
      '£3.9K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Carpet Cleaning UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for carpet cleaning businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for carpet cleaning UK, carpet cleaning business software, carpet cleaning customer management, carpet cleaning lead generation UK"
        url="/industries/carpet-cleaning"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default CarpetCleaning;